module.exports = __webpack_public_path__ + "img/A58A0655_min.f041b0dc.jpg";